module.exports = __webpack_public_path__ + "img/Vollbrand.a1df9140.svg";